import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Block } from '@haldor/ui';
import DOMPurify from "dompurify";
import './_outcomes.scss';
var Outcomes = /*#__PURE__*/function (_Component) {
  function Outcomes() {
    _classCallCheck(this, Outcomes);
    return _callSuper(this, Outcomes, arguments);
  }
  _inherits(Outcomes, _Component);
  return _createClass(Outcomes, [{
    key: "render",
    value: function render() {
      var _this$props$outcomes = this.props.outcomes,
        rubric = _this$props$outcomes.rubric,
        rubricOutcomes = _this$props$outcomes.rubricOutcomes;
      return /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("div", {
        className: "outcomes"
      }, rubric.qualities.map(function (quality) {
        var outcome = rubricOutcomes.find(function (outcome) {
          return outcome.qualityId == quality.qualityId;
        });
        return /*#__PURE__*/React.createElement("div", {
          className: "rubric",
          key: quality.qualityId
        }, /*#__PURE__*/React.createElement("div", {
          className: "rubric-content"
        }, /*#__PURE__*/React.createElement("div", {
          className: "description"
        }, quality.description.content), /*#__PURE__*/React.createElement("div", {
          className: "levels"
        }, rubric.levels.map(function (level, levelIndex) {
          var criteria = quality.criteria[levelIndex];
          var isMarked = false;
          if (outcome != null) {
            isMarked = outcome.levelId == level.levelId;
          }
          return /*#__PURE__*/React.createElement("div", {
            className: "level".concat(isMarked ? ' marked' : ''),
            key: level.levelId
          }, /*#__PURE__*/React.createElement("strong", null, level.displayName), criteria != null ? criteria : null);
        }))), outcome != null && outcome.feedback != null ? /*#__PURE__*/React.createElement("div", {
          className: "rubric-feedback"
        }, /*#__PURE__*/React.createElement("strong", null, "Feedback"), /*#__PURE__*/React.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize(outcome.feedback)
          }
        })) : null);
      })));
    }
  }]);
}(Component);
export default Outcomes;